
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "10 astuces efficaces pour prospecter sur Instagram en 2026",
    description:
      "Découvrez 10 astuces pour réussir votre prospection sur Instagram en 2026 et attirer de nouveaux clients grâce à des stratégies adaptées et engageantes.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
